import React from 'react';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import TextInput from './TextInput';

interface Props {
  question: FlowsQuestion;
}

/**
 * THIS COMPONENT IS TEMPORARY TO AVOID DATA TEST ID REFACTOR
 */
const TextInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { field, error, prefilled } = useFlowInputComponent({ question });

  return (
    <TextInput
      {...field}
      error={error?.message}
      type={question.rules.data_type?.toLowerCase() || 'text'}
      data-test-id="ProdFac_TextInputComponent"
      prefilled={prefilled}
      symbol={question.rules.symbol}
      isDisabled={question.rules.is_disabled}
    />
  );
};

export default TextInputComponent;
